// extracted by mini-css-extract-plugin
export default {"heroSlide":"HeroSection_heroSlide__bAyVi","heroTextWrapper":"HeroSection_heroTextWrapper__7o+xT"};